// import { loadAttributes } from "functions"
import UserContext from "global_state/context/UserContext"
import UserReducer from "global_state/reducer/UserReducer"
import { useReducer } from "react"

export interface UserI {
    client_id: string | null,
    connection_id: string | null,
}
const UserState = (props: any) => {
    // const {lang} = loadAttributes()
    
    let client_id: string | null = null
    let connection_id: string | null = null

    if ("xf_active_user" in sessionStorage) {
        // console.log('xf_active_user');
        let xf_user = JSON.parse(sessionStorage.getItem('xf_active_user') || "") as UserI
        client_id = xf_user?.client_id
        connection_id = xf_user?.connection_id
    }
    // console.log('session Storage'.toUpperCase());
    
    // console.log(sessionStorage);
    
    
    const init_state_user_context = {
        client_id: client_id,
        connection_id: connection_id
    }
    
    
    const [user, dispatchUser] = useReducer(UserReducer, init_state_user_context)
    return (
        <UserContext.Provider value={{user, dispatchUser}}>
            {props.children}
        </UserContext.Provider>
    )
}

export default UserState